import CreditScoreIcon from '@mui/icons-material/CreditScore';
import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import PersonRemoveAlt1OutlinedIcon from '@mui/icons-material/PersonRemoveAlt1Outlined';
// import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import CampaignIcon from '@mui/icons-material/Campaign';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import FeedOutlinedIcon from '@mui/icons-material/FeedOutlined';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import LiveHelpOutlinedIcon from '@mui/icons-material/LiveHelpOutlined';
import ManageHistoryOutlinedIcon from '@mui/icons-material/ManageHistoryOutlined';
import PaidIcon from '@mui/icons-material/Paid';
import { Badge } from '@mui/material';
import { RolesTypes } from '../../../../../../config/roles';
import { AppRoutes } from '../../../../../../constants/appRoutes';
import { checkPermissions } from '../../../../../../helpers/checkPermissionHelper';
import { buildRegionizeRoute } from '../../../../../../helpers/regionRouteHelper';

export const NavigationItems = ({ transactionCount = 0 }) => {
	return [
		{
			title: 'Dashboard',
			path: AppRoutes.Dashboard,
			icon: <DashboardCustomizeOutlinedIcon />,
			hide: false,
		},
		{
			title: 'Subscribers',
			icon: <GroupAddIcon />,
			path: buildRegionizeRoute(`${AppRoutes.Subscribers}`),
			hide: !checkPermissions(RolesTypes.Subscribers),
		},
		{
			title: 'Investors',
			icon: <PersonAddAltOutlinedIcon />,
			path: buildRegionizeRoute(`${AppRoutes.Investor}`),
			hide: !checkPermissions(RolesTypes.Investors),
		},
		{
			title: 'Borrowers',
			icon: <PersonRemoveAlt1OutlinedIcon />,
			path: buildRegionizeRoute(`${AppRoutes.Borrowers}`),
			hide: !checkPermissions(RolesTypes.Borrowers),
		},
		{
			title: 'Loans',
			icon: <CreditScoreIcon />,
			path: buildRegionizeRoute(`${AppRoutes.Loans}`),
			hide: !checkPermissions(RolesTypes.Loans),
		},
		{
			title: 'Transactions',
			path: buildRegionizeRoute(`${AppRoutes.Transactions}`),
			icon: <PaidIcon />,
			badge: (
				<Badge
					max={99999}
					showZero={true}
					badgeContent={transactionCount}
					color="error"></Badge>
			),
			hide: !checkPermissions(RolesTypes.Transactions),
		},
		{
			title: 'Members',
			path: buildRegionizeRoute(`${AppRoutes.Members}`),
			icon: <PeopleOutlineOutlinedIcon />,
			hide: !checkPermissions(RolesTypes.TeamMemberCRUD),
		},
		// {
		// 	title: 'Buckets',
		// 	path: buildRegionizeRoute(`${AppRoutes.Bucket}`),
		// 	icon: <StorageOutlinedIcon />,
		// 	hide: !checkPermissions(RolesTypes.Buckets),
		// },
		{
			title: 'Auto Investment',
			path: buildRegionizeRoute(`${AppRoutes.AutoInvestment}`),
			icon: <ManageHistoryOutlinedIcon />,
			hide: !checkPermissions(RolesTypes.AutoInvestment),
		},
		// {
		// 	title: 'Notifications',
		// 	path: `/${AppRoutes.Notification}`,
		// 	icon: <NotificationsNoneOutlinedIcon />,
		// },
		{
			title: 'Notifications',
			icon: <FeedOutlinedIcon />,
			hide: !checkPermissions('', [
				RolesTypes.PushNotifications,
				RolesTypes.SMSNotifications,
			]),
			children: [
				{
					title: 'Push Notifications',
					path: buildRegionizeRoute(`${AppRoutes.PushNotification}`),
					hide: !checkPermissions(RolesTypes.PushNotifications),
				},
				{
					title: 'SMS',
					path: buildRegionizeRoute(`${AppRoutes.SMSNotification}`),
					hide: !checkPermissions(RolesTypes.SMSNotifications),
				},
			],
		},
		{
			title: 'Control Panel',
			path: buildRegionizeRoute(`${AppRoutes.ControlPanel}`),
			icon: <AdminPanelSettingsOutlinedIcon />,
			hide: !checkPermissions('', [
				RolesTypes.ControlPanelAmlList,
				RolesTypes.ControlPanelClient,
				RolesTypes.ControlPanelMetaTags,
				RolesTypes.ControlPanelSystemSettings,
			]),
		},
		{
			title: 'Static Pages',
			path: buildRegionizeRoute(`${AppRoutes.StaticPages}`),
			icon: <AutoStoriesIcon />,
			hide: !checkPermissions(RolesTypes.StaticPages),
		},
		{
			title: 'Announcement Bar',
			path: buildRegionizeRoute(`${AppRoutes.AnnouncementBar}`),
			icon: <CampaignIcon />,
			hide: !checkPermissions(RolesTypes.AnnouncementBar),
		},
		{
			title: 'Promo Code',
			path: buildRegionizeRoute(`${AppRoutes.PromotionalCode}`),
			icon: <CardGiftcardIcon />,
			hide: !checkPermissions(RolesTypes.PromotionalCode),
		},
		{
			title: 'CMS',
			icon: <FeedOutlinedIcon />,
			hide: !checkPermissions('', [
				RolesTypes.BlogArticleCRUD,
				RolesTypes.BlogCategoryCRUD,
				RolesTypes.ComparisonCRUD,
			]),
			children: [
				{
					title: 'Article Categories',
					path: buildRegionizeRoute(
						`${AppRoutes.Blog}/${AppRoutes.BlogCategory}`
					),
					icon: null,
					hide: !checkPermissions(RolesTypes.BlogCategoryCRUD),
				},
				{
					title: 'Articles',
					path: buildRegionizeRoute(
						`${AppRoutes.Blog}/${AppRoutes.BlogArticle}`
					),
					icon: null,
					hide: !checkPermissions(RolesTypes.BlogArticleCRUD),
				},
				{
					title: 'Reviews',
					path: buildRegionizeRoute(
						`${AppRoutes.CompetitorsComparisons}`
					),
					icon: null,
					hide: !checkPermissions(RolesTypes.ComparisonCRUD),
				},
			],
		},
		{
			title: 'FAQs',
			icon: <LiveHelpOutlinedIcon />,
			hide: !checkPermissions('', [
				RolesTypes.FAQCategoryCRUD,
				RolesTypes.FAQItemsCRUD,
			]),
			children: [
				{
					title: 'Categories',
					path: buildRegionizeRoute(
						`${AppRoutes.FAQ}/${AppRoutes.FAQCategory}`
					),
					icon: null,
					hide: !checkPermissions(RolesTypes.FAQCategoryCRUD),
				},
				{
					title: 'Questions',
					path: buildRegionizeRoute(
						`${AppRoutes.FAQ}/${AppRoutes.FAQQuestions}`
					),
					icon: null,
					hide: !checkPermissions(RolesTypes.FAQItemsCRUD),
				},
			],
		},
		{
			title: 'Reports',
			icon: <AssessmentOutlinedIcon />,
			hide: !checkPermissions(RolesTypes.Reports),
			children: [
				{
					title: 'Investors Sign up',
					path: buildRegionizeRoute(
						`${AppRoutes.Reports}/${AppRoutes.ReportInvestorSignUp}`
					),
					icon: null,
				},
				{
					title: 'Borrowers Sign up',
					path: buildRegionizeRoute(
						`${AppRoutes.Reports}/${AppRoutes.ReportBorrowerSignUp}`
					),
					icon: null,
				},
				{
					title: 'Approved Investors',
					path: buildRegionizeRoute(
						`${AppRoutes.Reports}/${AppRoutes.ReportApprovedInvestor}`
					),
					icon: null,
				},
				{
					title: 'Borrowers Shareholders',
					path: buildRegionizeRoute(
						`${AppRoutes.Reports}/${AppRoutes.ReportBorrowerShareholders}`
					),
					icon: null,
				},
				{
					title: 'Investors Shareholders',
					path: buildRegionizeRoute(
						`${AppRoutes.Reports}/${AppRoutes.ReportCorporateInvestorShareholder}`
					),
					icon: null,
				},
				{
					title: 'Investor Deposit',
					path: buildRegionizeRoute(
						`${AppRoutes.Reports}/${AppRoutes.ReportInvestorsDeposit}`
					),
					icon: null,
				},
				{
					title: 'Investor Withdrawals',
					path: buildRegionizeRoute(
						`${AppRoutes.Reports}/${AppRoutes.ReportInvestorsWithdrawal}`
					),
					icon: null,
				},
				{
					title: 'Loan Tape',
					path: buildRegionizeRoute(
						`${AppRoutes.Reports}/${AppRoutes.ReportLoanTape}`),
					icon: null,
				},
				{
					title: 'AECB',
					path: buildRegionizeRoute(
						`${AppRoutes.Reports}/${AppRoutes.ReportAECB}`
					),
					icon: null,
				},
				{
					title: 'CRS Data',
					path: buildRegionizeRoute(
						`${AppRoutes.Reports}/${AppRoutes.ReportCRSData}`
					),
					icon: null,
				},
				{
					title: 'DFSA-Investors in Opportunities',
					path: buildRegionizeRoute(
						`${AppRoutes.Reports}/${AppRoutes.ReportDFSAOpportunities}`
					),
					icon: null,
				},
				{
					title: 'DFSA-Regions',
					path: buildRegionizeRoute(
						`${AppRoutes.Reports}/${AppRoutes.ReportDFSA}`
					),
					icon: null,
				},
				// {
				// 	title: 'Investor Acquisition Channels (SEO)',
				// 	path: buildRegionizeRoute(
				// 		`${AppRoutes.Reports}/${AppRoutes.ReportInvestorAcquisitionChannels}`
				// 	),
				// 	icon: null,
				// },
				{
					title: 'Marketing',
					path: buildRegionizeRoute(
						`${AppRoutes.Reports}/${AppRoutes.ReportMarketing}`),
					icon: null,
				},
				{
					title: 'Promo Code',
					path: buildRegionizeRoute(
						`${AppRoutes.Reports}/${AppRoutes.ReportPromoCode}`
					),
					icon: null,
				},
				{
					title: 'User Survey',
					path: buildRegionizeRoute(
						`${AppRoutes.Reports}/${AppRoutes.ReportUserSurvey}`
					),
					icon: null,
				},
			],
		},
	];
};
